import Vue from 'vue';
import Router from 'vue-router';
import GoldenFoodAnnualList2019 from '@/views/2019GoldenFoodAnnualList';
import GloriousSeventyYears2019 from './views/2019GloriousSeventyYears';
import TopTenChongqingMerchants2019 from '@/views/2019TopTenChongqingMerchants/index';
import VoteForTopTenChongqingMerchants2019 from '@/views/2019VoteForTopTenChongqingMerchants/index';
import MetroSmallTheater2019 from '@/views/2019MetroSmallTheater';
import ShangyouAnswerRanking2019 from '@/views/2019ShangyouAnswerRanking';
import TheEighthChinaInnovationCompetition2019 from '@/views/2019TheEighthChinaInnovationCompetition';
import GoAheadChina2019 from '@/views/2019GoAheadChina';
import MemorialDay2019 from '@/views/2019MemorialDay';
import VolunteerSelection2019 from '@/views/2019VolunteerSelection';
import HealthAnniversary2019 from '@/views/2019HealthAnniversary';
import AdvancerVolunteerSelection2019 from '@/views/2019AdvancerVolunteerSelection';
import GarbageClassification2019 from '@/views/2019CqGarbageClassification';
import FootballBootCamp2019 from '@/views/2019FootballBootCamp';
import QuestionMaster2019 from '@/views/2019QuestionMaster';
import VoteForShangYouHao2019 from '@/views/2019VoteForShangYouHao';
import HealthContributionBrand2019 from '@/views/2019HealthContributionBrand';
import LaborAndSkillCompetition2019 from '@/views/2019LaborAndSkillCompetition';
import AssociationEcologyMeeting2019 from '@/views/2019AssociationEcologyMeeting';
import PaintingAndCalligraphyCompetition from '@/views/2019PaintingAndCalligraphyCompetition';
import BangBangActivityList from '@/views/2019BangBangActivityList';
import ConsumerGoods from '@/views/2019ConsumerGoods';
import FMXY2019 from '@/views/2019FMXY';
import KJHLW2019 from '@/views/2019KJHLW';
import Legalvolunteer from '@/views/2019Legalvolunteer';
import XHZW2019 from '@/views/2019XHZW';
import CQJR from '@/views/2019ListOfFinancial';
import PAJS from '@/views/2019PAJS';
import LJFL from '@/views/2019LJFL';
import CQYFJ from '@/views/2019CQYFJ';
import HBZYZPX2019 from '@/views/2019HBZYZPS';
import Zxqyxcy from '@/views/2019Zxqyxcy';
import CommercialBrand2019 from '@/views/2019CommercialBrand';
import GSD from '@/views/2019GSD';
import ZMJTZYZ2019 from '@/views/ZMJTZYZ2019';
import NotFound from '@/views/NotFound';
import NewWishes2019 from '@/views/2019NewWishes';
import CQXF2019 from '@/views/2019CQXF';
import BreakTheLimit2019 from '@/views/2019BreakTheLimit';
import LJBY2019 from '@/views/2019LJBY';
import QuestionMasterSecond2019 from '@/views/2019QuestionMasterSecond';
import JJFP2019 from '@/views/2019JJFP';
Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: () => import('@/views/HelloWorld.vue'),
    },
    {
      path: '/loading',
      name: 'loadingPage',
      component: () => import('@/views/Loading.vue'),
    },
    {
      path: '/news',
      name: 'News',
      component: () => import('@/views/News.vue'),
    },
    {
      path: '/apidemo',
      name: 'ApiDemo',
      component: () => import('@/views/demo/ApiDemo.vue'),
    },
    {
      path: '/weChatLogin',
      name: 'weChatLogin',
      component: () => import('@/views/WeChatLoginPage.vue'),
    },
    {
      path: '/2019GoldenFoodAnnualList/ShowPage',
      component: () => import('@/views/2019GoldenFoodAnnualList/ShowPage.vue'),
      name: 'GoldenFoodAnnualListShowPage',
      meta: {
        title: '第二届“重庆美食年度金榜”大型融媒体评选活动',
      },
    },
    // 第二届“重庆美食年度金榜”大型融媒体评选活动
    GoldenFoodAnnualList2019,
    // 渝商评选一期
    TopTenChongqingMerchants2019,
    // 渝商评选二期
    VoteForTopTenChongqingMerchants2019,
    // 壮丽70年，老区换新颜
    GloriousSeventyYears2019,
    // 都市小剧场
    MetroSmallTheater2019,
    // 上游新闻答人排行榜
    ShangyouAnswerRanking2019,
    // 第八届中国创新创业大赛“重庆·大足锻打刀具创意设计专业赛”
    TheEighthChinaInnovationCompetition2019,
    // 前进，中国！
    GoAheadChina2019,
    // 永远的丰碑，网上纪英烈
    MemorialDay2019,
    // 最美扶贫志愿者评选
    VolunteerSelection2019,
    // 健康70周年
    HealthAnniversary2019,
    // 先进志愿者评选
    AdvancerVolunteerSelection2019,
    // 2019垃圾分类一期
    GarbageClassification2019,
    // 上游天才足球青训营
    FootballBootCamp2019,
    // 上游爱问达人
    QuestionMaster2019,
    // 上游号投票
    VoteForShangYouHao2019,
    HealthContributionBrand2019,
    AssociationEcologyMeeting2019,
    // 乡村学校少年宫书法大赛
    PaintingAndCalligraphyCompetition,
    // 上游帮帮活动
    BangBangActivityList,
    // 重庆市2019年度消费品
    ConsumerGoods,
    // 富民兴余
    FMXY2019,
    // 科技互联网
    KJHLW2019,
    // 最美法律志愿者
    Legalvolunteer,
    // 携号转网
    XHZW2019,
    // 重庆金融榜
    CQJR,
    // 一路有你平安建设
    PAJS,
    // 垃圾分类
    LJFL,
    // 重庆药房节
    CQYFJ,
    // 最美生态环保志愿者评选
    HBZYZPX2019,
    // 重庆商业品牌风云榜
    CommercialBrand2019,
    // 高速带我文明游
    GSD,
    // 中小企业政策宣传月
    Zxqyxcy,
    // 2019最美交通志愿者
    ZMJTZYZ2019,
    // 2020重庆我们的新期待
    NewWishes2019,
    // 2020重庆消防主题宣传
    CQXF2019,
    // Break the Limit-创·无界首届国际青年短视频大赛
    BreakTheLimit2019,
    // 2019两江榜样
    LJBY2019,
    // 上游爱问达人第二期
    QuestionMasterSecond2019,
    JJFP2019,
    // 聚焦扶贫
  ],
  // 跳转后回到顶部
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0, // 离奇bug，只有当y不为0的时候，keep-alive页面在 activated 的时候才会记住滚动位置;
    };
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = (router as Router & { history: any }).history.pending
    .fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;
